// extracted by mini-css-extract-plugin
export default {"trusted":"trusted_trusted__jP-HN","trustedIcon":"trusted_trustedIcon__aqdIw"};